import { render } from "./AncestorTreeUnified.vue?vue&type=template&id=bdb402f8&scoped=true"
import script from "./AncestorTreeUnified.vue?vue&type=script&lang=js"
export * from "./AncestorTreeUnified.vue?vue&type=script&lang=js"

import "./AncestorTreeUnified.vue?vue&type=style&index=0&id=bdb402f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdb402f8"]])

export default __exports__